/* ============================================================
   SARTE LEATHER — global.js
   Vanilla JS. No dependencies. Delegated events so Theme
   Editor section re-renders keep working.
   ============================================================ */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Utilities ---------- */
  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function lockScroll(lock) {
    document.body.classList.toggle('no-scroll', lock);
  }

  function trapFocus(container, e) {
    var focusables = $$('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', container)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!focusables.length) return;
    var first = focusables[0], last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- Free shipping progress ---------- */
  function renderShipProgress(subtotalCents) {
    var threshold = window.SARTE && window.SARTE.freeShipThreshold ? window.SARTE.freeShipThreshold : 500000;
    var fills = $$('[data-ship-fill]');
    var messages = $$('[data-ship-message]');
    if (!fills.length || !messages.length) return;
    var pct = Math.min(100, Math.round((subtotalCents / threshold) * 100));
    var template = window.SARTE && window.SARTE.freeShipMessage ? window.SARTE.freeShipMessage : 'Rs. {amount} away from FREE DELIVERY';
    var unlocked = window.SARTE && window.SARTE.freeShipUnlocked ? window.SARTE.freeShipUnlocked : 'FREE DELIVERY UNLOCKED';
    fills.forEach(function (fill) { fill.style.width = pct + '%'; });
    messages.forEach(function (msg) {
      if (subtotalCents >= threshold) {
        msg.textContent = unlocked;
      } else {
        var remaining = (threshold - subtotalCents) / 100;
        msg.textContent = template.replace('{amount}', 'Rs. ' + Math.round(remaining).toLocaleString('en-PK'));
      }
    });
  }

  /* ---------- Cart (AJAX) ---------- */
  var cartDrawer = $('[data-cart-drawer]');
  var overlay = $('[data-drawer-overlay]');
  var cartSyncVersion = 0;
  var cartQueue = Promise.resolve();

  function openDrawer(drawer) {
    var target = drawer || $('[data-cart-drawer]');
    if (!target) return;
    target.hidden = false;
    requestAnimationFrame(function () { target.classList.add('is-open'); });
    var currentOverlay = overlay || $('[data-drawer-overlay]');
    if (currentOverlay) { currentOverlay.hidden = false; currentOverlay.classList.add('is-visible'); }
    lockScroll(true);
    var closeBtn = $('[data-drawer-close]', target);
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawers() {
    $$('.drawer.is-open, .cart-drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    $$('.filter-drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    if (overlay) overlay.classList.remove('is-visible');
    setTimeout(function () {
      $$('.cart-drawer, .drawer').forEach(function (d) {
        if (d.closest('.filter-drawer')) return; /* filter drawer is controlled by its own wrapper */
        if (!d.classList.contains('is-open')) d.hidden = true;
      });
      if (overlay) overlay.hidden = true;
    }, 320);
    lockScroll(false);
  }

  function formatMoney(cents) {
    var sym = window.SARTE && window.SARTE.currency ? window.SARTE.currency : 'Rs.';
    return sym + ' ' + (cents / 100).toLocaleString('en-PK', { minimumFractionDigits: 0 });
  }

  function cartItemImage(url, title) {
    if (!url) return '';
    return '<img src="' + escapeHtml(url) + '" alt="' + escapeHtml(title || '') + '" loading="lazy">';
  }

  function setCartBusy(isBusy) {
    $$('[data-cart-body]').forEach(function (b) { b.classList.toggle('is-busy', !!isBusy); });
  }

  function renderCartItems(cart) {
    var bodies = $$('[data-cart-body]');
    if (bodies.length) {
      var html = '';
      if (!cart.items.length) {
        html = '<div class="cart-drawer__empty" data-cart-empty><p>Your cart is empty.</p>' +
          '<a href="/collections/all" class="btn btn--primary">Continue Shopping</a></div>';
      } else {
        html = '<ul class="cart-items" data-cart-items>' + cart.items.map(function (item, i) {
          var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-item__variant">' + escapeHtml(item.variant_title) + '</p>' : '';
          var oldPrice = item.original_line_price > item.final_line_price ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '';
          return '<li class="cart-item" data-line="' + (i + 1) + '" data-key="' + escapeHtml(item.key) + '">' +
            '<a href="' + escapeHtml(item.url) + '" class="cart-item__img">' + cartItemImage(item.image, item.product_title) + '</a>' +
            '<div class="cart-item__details"><a href="' + escapeHtml(item.url) + '" class="cart-item__title">' + escapeHtml(item.product_title) + '</a>' + variant +
            '<div class="cart-item__meta"><span class="cart-item__unit-price">' + formatMoney(item.final_price) + ' each</span>' + (item.quantity > 1 ? '<span class="cart-item__qty-label">Qty ' + item.quantity + '</span>' : '') + '</div>' +
            '<div class="cart-item__controls"><div class="qty-input qty-input--sm">' +
            '<button type="button" data-qty-minus aria-label="Decrease quantity">&minus;</button>' +
            '<input type="number" value="' + item.quantity + '" min="0" aria-label="Quantity" data-qty-input>' +
            '<button type="button" data-qty-plus aria-label="Increase quantity">+</button></div>' +
            '<button type="button" class="cart-item__remove" data-line-remove>Remove</button></div></div>' +
            '<div class="cart-item__price">' + oldPrice + '<span>' + formatMoney(item.final_line_price) + '</span></div></li>';
        }).join('') + '</ul>';
      }
      bodies.forEach(function (body) {
        body.innerHTML = html;
        body.classList.remove('is-busy');
      });
    }
    $$('[data-cart-foot]').forEach(function (foot) {
      foot.hidden = !cart.item_count;
    });
    renderShipProgress(cart.total_price);
    $$('[data-cart-subtotal]').forEach(function (subtotal) {
      subtotal.textContent = formatMoney(cart.total_price);
    });
    $$('[data-cart-discount]').forEach(function (discount) {
      var discountAmount = Number(cart.total_discount || 0);
      discount.hidden = discountAmount <= 0;
      var value = $('[data-cart-discount-value]', discount);
      if (value) value.textContent = formatMoney(discountAmount);
    });
  }

  function refreshCartUI(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = '(' + cart.item_count + ')';
    });
    $$('[data-cart-item-label]').forEach(function (el) {
      el.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    });
    $$('.badge-count').forEach(function (el) {
      if (el.closest('.filter-drawer-btn')) return; /* shop filter badge is not the cart badge */
      el.textContent = cart.item_count;
      el.style.display = cart.item_count ? '' : 'none';
    });
    renderCartItems(cart);
    document.dispatchEvent(new CustomEvent('sarte:cart:updated', { detail: cart }));
  }

  function fetchCartState() {
    return fetch(window.routes.cart_url + '.js?cart_sync=' + Date.now(), {
      cache: 'no-store',
      headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' }
    }).then(function (r) {
      if (!r.ok) throw new Error('cart read failed');
      return r.json();
    });
  }

  function updateCartCounts() {
    var version = ++cartSyncVersion;
    return fetchCartState().then(function (cart) {
      if (version === cartSyncVersion) refreshCartUI(cart);
      return cart;
    }).catch(function () {
      setCartBusy(false);
      return null;
    });
  }

  /* Runs cart changes one after another so quick taps can never race each other */
  function queueCart(task) {
    var run = cartQueue.then(task);
    cartQueue = run.catch(function () {});
    return run;
  }

  function cartRequest(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) {
          var err = new Error((j && (j.description || j.message)) || 'Request failed');
          err.userMessage = j && (j.description || j.message);
          throw err;
        }
        return j;
      });
    });
  }

  function changeLine(key, qty, line) {
    return queueCart(function () {
      ++cartSyncVersion;
      setCartBusy(true);
      var payload = key ? { id: key, quantity: qty } : { line: line, quantity: qty };
      return cartRequest(window.routes.cart_change_url + '.js', payload).then(function (cart) {
        ++cartSyncVersion;
        refreshCartUI(cart);
        return cart;
      }).catch(function (err) {
        setCartStatus((err && err.userMessage) || 'Could not update your cart. Please try again.', true);
        return updateCartCounts();
      });
    });
  }

  function addToCart(variantId, qty, done) {
    var quantity = Math.max(1, parseInt(qty, 10) || 1);
    return queueCart(function () {
      ++cartSyncVersion;
      setCartBusy(true);
      return cartRequest(window.routes.cart_add_url + '.js', {
        items: [{ id: Number(variantId), quantity: quantity }]
      }).then(function () {
        return fetchCartState().catch(function () { return fetchCartState(); });
      }).then(function (cart) {
        ++cartSyncVersion;
        refreshCartUI(cart);
        if (done) done(true, null);
        return cart;
      }).catch(function (err) {
        updateCartCounts();
        if (done) done(false, err && err.userMessage ? err.userMessage : null);
        return null;
      });
    });
  }

  function setCartStatus(message, isError) {
    $$('[data-cart-status]').forEach(function (el) {
      el.textContent = message || '';
      el.classList.toggle('is-error', !!isError);
    });
  }

  /* ---------- PDP AJAX add-to-cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-pdp-form]');
    if (!form) return;
    var submitter = e.submitter;
    if (submitter && submitter.matches('[data-buy-now]')) return;

    var variantInput = $('[data-variant-id-input]', form);
    var qtyInput = $('[data-pdp-qty]', form);
    var button = $('[data-pdp-atc]', form);
    if (!variantInput || !variantInput.value || !button || button.disabled) return;

    e.preventDefault();
    e.stopPropagation();

    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    button.classList.add('is-loading');
    button.disabled = true;
    openDrawer(cartDrawer);
    setCartStatus('Adding to your bag…');

    addToCart(variantInput.value, qty, function (ok, message) {
      button.classList.remove('is-loading');
      button.disabled = false;
      var feedback = $('[data-pdp-atc-feedback]');
      if (ok) {
        setCartStatus('Added to your bag.');
        if (feedback) {
          feedback.textContent = 'Added to your cart.';
          feedback.classList.add('is-success');
          feedback.classList.remove('is-error');
        }
      } else {
        setCartStatus(message || 'Could not add this item. Please try again.', true);
        if (feedback) {
          feedback.textContent = message || 'Something went wrong. Please try again.';
          feedback.classList.add('is-error');
          feedback.classList.remove('is-success');
        }
      }
    });
  });

  /* ---------- PDP action modals ---------- */
  document.addEventListener('click', function (e) {
    var target = e.target.closest('[data-product-share], [data-question-open], [data-pdp-share-close], [data-pdp-question-close]');
    if (!target) return;
    var section = target.closest('[data-pdp]');
    if (!section) return;

    var shareModal = section.querySelector('[data-pdp-share-modal]');
    var questionModal = section.querySelector('[data-pdp-question-modal]');

    function openModal(modal) {
      if (!modal) return;
      try {
        if (typeof modal.showModal === 'function' && !modal.open) {
          modal.showModal();
        } else {
          modal.setAttribute('open', '');
        }
      } catch (error) {
        modal.setAttribute('open', '');
      }
      modal.classList.add('is-open');
      document.body.classList.add('no-scroll');
    }

    function closeModal(modal) {
      if (!modal) return;
      try {
        if (typeof modal.close === 'function' && modal.open) {
          modal.close();
        } else {
          modal.removeAttribute('open');
        }
      } catch (error) {
        modal.removeAttribute('open');
      }
      modal.classList.remove('is-open');
      var stillOpen = section.querySelector('[data-pdp-share-modal][open], [data-pdp-question-modal][open]');
      if (!stillOpen) document.body.classList.remove('no-scroll');
    }

    if (target.matches('[data-product-share]')) {
      e.preventDefault();
      e.stopPropagation();
      openModal(shareModal);
      return;
    }

    if (target.matches('[data-question-open]')) {
      e.preventDefault();
      e.stopPropagation();
      openModal(questionModal);
      return;
    }

    if (target.matches('[data-pdp-share-close]')) {
      e.preventDefault();
      e.stopPropagation();
      closeModal(shareModal);
      return;
    }

    if (target.matches('[data-pdp-question-close]')) {
      e.preventDefault();
      e.stopPropagation();
      closeModal(questionModal);
    }
  }, true);

  document.addEventListener('click', function (e) {
    var modal = e.target.closest('[data-pdp-share-modal], [data-pdp-question-modal]');
    if (modal && e.target === modal) {
      try {
        if (typeof modal.close === 'function' && modal.open) modal.close();
        else modal.removeAttribute('open');
      } catch (error) {
        modal.removeAttribute('open');
      }
      modal.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
    }
  }, true);

  document.addEventListener('close', function (e) {
    var modal = e.target.closest ? e.target.closest('[data-pdp-share-modal], [data-pdp-question-modal]') : null;
    if (modal) {
      modal.classList.remove('is-open');
      var anyOpen = document.querySelector('[data-pdp-share-modal][open], [data-pdp-question-modal][open]');
      if (!anyOpen) document.body.classList.remove('no-scroll');
    }
  }, true);

  /* ---------- Global click delegation ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    // Open cart drawer buttons (on the cart page itself there is no drawer, so just follow the link)
    if (t.closest('[data-cart-open]')) {
      if (!$('[data-cart-drawer]')) return;
      e.preventDefault();
      updateCartCounts();
      openDrawer(cartDrawer || $('[data-cart-drawer]'));
      return;
    }
    // Close drawers
    if (t.closest('[data-drawer-close]') || t === overlay) { closeDrawers(); return; }

    // Mobile menu open
    if (t.closest('[data-menu-open]')) {
      e.preventDefault();
      openDrawer($('[data-mobile-drawer]'));
      return;
    }
    // Search open
    if (t.closest('[data-search-open]')) {
      e.preventDefault();
      openDrawer($('[data-search-drawer]'));
      var input = $('#SearchDrawerInput');
      if (input) setTimeout(function () { input.focus(); }, 250);
      return;
    }
    // Filter drawer
    if (t.closest('[data-filter-open]')) {
      e.preventDefault();
      var fd = $('[data-filter-drawer]');
      if (fd) {
        var fdDrawer = $('.drawer', fd);
        if (fdDrawer) fdDrawer.hidden = false;
        fd.classList.add('is-open');
        lockScroll(true);
        if (overlay) { overlay.hidden = false; overlay.classList.add('is-visible'); }
      }
      return;
    }
    if (t.closest('[data-filter-close]')) {
      var fd2 = t.closest('.filter-drawer');
      if (fd2) { fd2.classList.remove('is-open'); closeDrawers(); }
      return;
    }
    if (t.closest('[data-filter-apply]')) {
      var form = t.closest('.filter-drawer') ? $('form', t.closest('.filter-drawer')) : null;
      if (form) form.submit();
      return;
    }
    if (t.closest('[data-filter-clear]')) {
      window.location.href = window.location.pathname;
      return;
    }

    // Drawer accordion (mobile nav submenus + footer accordions + facets)
    var accBtn = t.closest('[data-acc-btn]');
    if (accBtn) {
      var panel = document.getElementById(accBtn.getAttribute('aria-controls'));
      var open = accBtn.getAttribute('aria-expanded') === 'true';
      var nextOpen = !open;
      accBtn.setAttribute('aria-expanded', String(nextOpen));
      if (panel) panel.style.maxHeight = nextOpen ? panel.scrollHeight + 'px' : '0px';
      return;
    }

    // Generic accordion (product details, FAQ)
    var gAcc = t.closest('[data-accordion-btn]');
    if (gAcc) {
      var gPanel = document.getElementById(gAcc.getAttribute('aria-controls'));
      var gOpen = gAcc.getAttribute('aria-expanded') === 'true';
      var gNext = !gOpen;
      var group = gAcc.closest('[data-accordion-group]');

      if (group && group.hasAttribute('data-single-open') && gNext) {
        $$('[data-accordion-btn]', group).forEach(function (b) {
          if (b !== gAcc) {
            b.setAttribute('aria-expanded', 'false');
            var p = document.getElementById(b.getAttribute('aria-controls'));
            if (p) {
              p.style.maxHeight = '0px';
              p.setAttribute('aria-hidden', 'true');
            }
          }
        });
      }

      gAcc.setAttribute('aria-expanded', String(gNext));
      if (gPanel) {
        gPanel.style.maxHeight = gNext ? gPanel.scrollHeight + 'px' : '0px';
        gPanel.setAttribute('aria-hidden', String(!gNext));
      }
      return;
    }

    // Add-to-cart buttons on cards (and the wishlist page)
    var atc = t.closest('[data-card-atc]');
    if (atc) {
      e.preventDefault();
      if (atc.disabled || atc.classList.contains('is-loading')) return;
      atc.classList.add('is-loading');
      openDrawer(cartDrawer);
      setCartStatus('Adding to your bag…');
      addToCart(atc.getAttribute('data-variant-id'), 1, function (ok, message) {
        atc.classList.remove('is-loading');
        if (ok) {
          setCartStatus('Added to your bag.');
          var drawerBody = cartDrawer ? $('[data-cart-body]', cartDrawer) : null;
          if (drawerBody) drawerBody.scrollTop = 0;
        } else {
          setCartStatus(message || 'Could not add this item. Please try again.', true);
        }
      });
      return;
    }

    // Wishlist toggles
    var wish = t.closest('[data-wishlist-toggle]');
    if (wish) {
      e.preventDefault();
      toggleWishlist(wish);
      return;
    }

    // Qty inputs
    var minus = t.closest('[data-qty-minus]');
    var plus = t.closest('[data-qty-plus]');
    if (minus || plus) {
      var wrap = t.closest('.qty-input');
      var qinput = wrap ? $('input', wrap) : null;
      if (qinput) {
        var v = parseInt(qinput.value, 10) || 0;
        qinput.value = Math.max(0, v + (plus ? 1 : -1));
        qinput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    // Cart remove (removes the row instantly, then syncs with Shopify)
    var removeBtn = t.closest('[data-line-remove]');
    var removeItem = removeBtn ? removeBtn.closest('.cart-item') : null;
    if (removeItem) {
      e.preventDefault();
      removeItem.classList.add('cart-item--removing');
      changeLine(removeItem.getAttribute('data-key'), 0, parseInt(removeItem.getAttribute('data-line'), 10));
      return;
    }

    // Back to top
    if (t.closest('[data-back-top]')) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      return;
    }
  });

  /* Qty change inside cart (drawer + cart page) */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('.cart-item [data-qty-input]');
    if (input) {
      var item = input.closest('.cart-item');
      var q = Math.max(0, parseInt(input.value, 10) || 0);
      if (q === 0) item.classList.add('cart-item--removing');
      changeLine(item.getAttribute('data-key'), q, parseInt(item.getAttribute('data-line'), 10));
    }
  });

  /* ---------- Escape key & focus trap ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var lb = $('.lightbox.is-open');
      if (lb) { closeLightbox(); return; }
      closeDrawers();
      return;
    }
    if (e.key === 'Tab') {
      var openDrawerEl = $('.drawer.is-open, .cart-drawer.is-open');
      if (openDrawerEl) trapFocus(openDrawerEl, e);
    }
  });

  /* Back/forward cache: always show the real cart */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) updateCartCounts();
  });

  /* ---------- Wishlist (localStorage guest fallback) ---------- */
  var WISH_KEY = 'sarte_wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; } catch (err) { return []; }
  }
  function toggleWishlist(btn) {
    var handle = btn.getAttribute('data-product-handle');
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx > -1) { list.splice(idx, 1); } else { list.push(handle); }
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (err) {}
    syncWishlistUI();
  }
  function syncWishlistUI() {
    var list = getWishlist();
    $$('[data-wishlist-toggle]').forEach(function (btn) {
      var active = list.indexOf(btn.getAttribute('data-product-handle')) > -1;
      btn.setAttribute('aria-pressed', String(active));
      var heart = $('.wish-heart', btn);
      if (heart) heart.classList.toggle('is-active', active);
    });
    var grid = $('[data-wishlist-grid]');
    if (grid) renderWishlistPage(grid, list);
  }

  function wishlistImage(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=640';
  }

  function wishlistCardMarkup(p) {
    var variants = p.variants || [];
    var buyable = variants.filter(function (x) { return x.available; })[0] || variants[0] || {};
    var onSale = p.compare_at_price && p.compare_at_price > p.price;
    var img = p.featured_image ? '<img src="' + escapeHtml(wishlistImage(p.featured_image)) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '';
    return '<article class="wishlist-card" data-wishlist-item>' +
      '<a class="wishlist-card__media" href="' + escapeHtml(p.url) + '" aria-label="' + escapeHtml(p.title) + '">' + img + '</a>' +
      '<button type="button" class="wishlist-card__remove" data-wishlist-toggle data-product-handle="' + escapeHtml(p.handle) + '" aria-label="Remove ' + escapeHtml(p.title) + ' from wishlist">' +
        '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
      '<div class="wishlist-card__body">' +
        (p.type ? '<p class="wishlist-card__eyebrow">' + escapeHtml(p.type) + '</p>' : '') +
        '<h3 class="wishlist-card__title"><a href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a></h3>' +
        '<div class="wishlist-card__price"><span>' + formatMoney(p.price) + '</span>' + (onSale ? '<s>' + formatMoney(p.compare_at_price) + '</s>' : '') + '</div>' +
        '<p class="wishlist-card__availability' + (p.available ? '' : ' is-unavailable') + '">' + (p.available ? 'In stock' : 'Sold out') + '</p>' +
        '<div class="wishlist-card__actions">' +
          '<button type="button" class="wishlist-card__add" data-card-atc data-variant-id="' + escapeHtml(buyable.id) + '"' + (p.available ? '' : ' disabled') + '>' + (p.available ? 'Add to cart' : 'Sold out') + '</button>' +
          '<button type="button" class="wishlist-card__remove-text" data-wishlist-toggle data-product-handle="' + escapeHtml(p.handle) + '">Remove</button>' +
        '</div>' +
      '</div></article>';
  }

  function renderWishlistPage(grid, handles) {
    var countEl = $('[data-wishlist-count]');
    var clearBtn = $('[data-wishlist-clear]');
    function setMeta(n) {
      if (countEl) countEl.textContent = n + (n === 1 ? ' item' : ' items');
      if (clearBtn) clearBtn.hidden = n === 0;
    }
    var emptyHtml = '<div class="wishlist-empty"><div class="wishlist-empty__mark" aria-hidden="true">&#9825;</div>' +
      '<h2>Your wishlist is empty</h2><p>Tap the heart on any product to save it here.</p>' +
      '<a class="btn btn--primary" href="/collections/all"><span>Browse Products</span></a></div>';
    if (!handles.length) {
      setMeta(0);
      grid.innerHTML = emptyHtml;
      return;
    }
    var token = (renderWishlistPage.token = (renderWishlistPage.token || 0) + 1);
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      if (token !== renderWishlistPage.token) return; /* a newer render is in progress */
      var found = products.filter(Boolean);
      setMeta(found.length);
      grid.innerHTML = found.length ? found.map(wishlistCardMarkup).join('') : emptyHtml;
      if (found.length) syncHearts();
    });
  }

  function syncHearts() {
    var list = getWishlist();
    $$('[data-wishlist-toggle]').forEach(function (btn) {
      var active = list.indexOf(btn.getAttribute('data-product-handle')) > -1;
      btn.setAttribute('aria-pressed', String(active));
    });
  }

  /* ---------- Announcement rotation ---------- */
  var annMsgs = $$('[data-announcement-msg]');
  if (annMsgs.length > 1 && !reduceMotion) {
    var ai = 0;
    var speedEl = $('[data-announcement-bar]');
    var speed = speedEl ? (parseInt(speedEl.getAttribute('data-rotation-speed'), 10) || 5) * 1000 : 5000;
    setInterval(function () {
      var cur = annMsgs[ai];
      ai = (ai + 1) % annMsgs.length;
      var nxt = annMsgs[ai];
      cur.style.opacity = '0';
      setTimeout(function () {
        cur.hidden = true;
        nxt.hidden = false;
        nxt.style.opacity = '0';
        requestAnimationFrame(function () { nxt.style.opacity = '1'; });
      }, 350);
    }, speed);
    annMsgs.forEach(function (m, i) { m.hidden = i !== 0; });
  }
  var annClose = $('[data-announcement-close]');
  if (annClose) {
    annClose.addEventListener('click', function () {
      var bar = $('[data-announcement-bar]');
      if (bar) bar.classList.add('announcement--hidden');
      try { sessionStorage.setItem('sarte_ann_closed', '1'); } catch (err) {}
    });
    try {
      if (sessionStorage.getItem('sarte_ann_closed') === '1') {
        var bar2 = $('[data-announcement-bar]');
        if (bar2) bar2.classList.add('announcement--hidden');
      }
    } catch (err) {}
  }

  /* ---------- Header sticky / compact ---------- */
  var header = $('[data-site-header]');
  if (header && header.hasAttribute('data-compact')) {
    var onScroll = function () {
      header.classList.toggle('is-compact', window.scrollY > 60);
      var bt = $('[data-back-top]');
      if (bt) bt.classList.toggle('is-visible', window.scrollY > 600);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  } else {
    var bt2 = $('[data-back-top]');
    if (bt2) {
      window.addEventListener('scroll', function () {
        bt2.classList.toggle('is-visible', window.scrollY > 600);
      }, { passive: true });
    }
  }

  /* ---------- Mega menu (keyboard + hover handled by CSS) ---------- */
  $$('[data-mega-trigger]').forEach(function (trigger) {
    var item = trigger.closest('.has-mega');
    trigger.addEventListener('focus', function () { item.classList.add('is-open'); });
    item.addEventListener('mouseleave', function () { trigger.setAttribute('aria-expanded', 'false'); });
    item.addEventListener('mouseenter', function () { trigger.setAttribute('aria-expanded', 'true'); });
    trigger.addEventListener('blur', function () {
      setTimeout(function () {
        if (!item.contains(document.activeElement)) item.classList.remove('is-open');
      }, 10);
    });
  });

  /* ---------- Predictive search ---------- */
  var searchInput = $('#SearchDrawerInput');
  var predictive = $('[data-predictive-results]');
  var searchTimer;
  var placeholderPhrases = [];
  var phEl = $('[data-search-drawer] [data-placeholders]');
  if (phEl) {
    try { placeholderPhrases = JSON.parse(phEl.getAttribute('data-placeholders')); } catch (err) {}
  }
  if (searchInput && placeholderPhrases.length && !reduceMotion) {
    var pi = 0, ci = 0, deleting = false;
    setInterval(function () {
      if (document.activeElement === searchInput && searchInput.value) return;
      var word = placeholderPhrases[pi];
      if (!deleting) {
        ci++;
        if (ci >= word.length) { deleting = true; ci = word.length; }
      } else {
        ci--;
        if (ci <= 0) { deleting = false; pi = (pi + 1) % placeholderPhrases.length; }
      }
      searchInput.setAttribute('placeholder', word.slice(0, ci));
    }, 90);
  }
  if (searchInput && predictive) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      if (q.length < 2) { predictive.innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            var html = '';
            if (products.length) {
              html += '<h3>Products</h3><div class="predictive__products">' + products.map(function (p) {
                var price = '';
                if (p.price) price = (window.SARTE && window.SARTE.currency ? window.SARTE.currency : 'Rs.') + ' ' + Math.round(parseFloat(p.price)).toLocaleString('en-PK');
                return '<a class="predictive__product" href="' + p.url + '">' +
                  (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') +
                  '<p>' + escapeHtml(p.title) + '</p><span class="price">' + price + '</span></a>';
              }).join('') + '</div>';
            } else {
              html += '<p style="color:var(--muted);padding:12px 0">No products found for &ldquo;' + escapeHtml(q) + '&rdquo;.</p>';
            }
            html += '<h3>Popular searches</h3><div class="predictive__terms">' +
              ['leather bags', 'wallets', 'belts', 'jackets'].map(function (term) {
                return '<a href="/search?q=' + encodeURIComponent(term) + '">' + term + '</a>';
              }).join('') + '</div>';
            predictive.innerHTML = html;
          })
          .catch(function () {});
      }, 250);
    });
  }

  /* ---------- Reveal on scroll ---------- */
  var revealEls = $$('.reveal');
  if (revealEls.length) {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -40px 0px' });
      revealEls.forEach(function (el) { io.observe(el); });
    }
  }

  /* ---------- Carousels (arrows) ---------- */
  $$('[data-carousel]').forEach(function (root) {
    var track = $('[data-carousel-track]', root);
    if (!track) return;
    var scope = root.parentElement || root;
    var prev = $('[data-carousel-prev]', scope), next = $('[data-carousel-next]', scope);
    var step = function () {
      var card = track.children[0];
      return card ? card.getBoundingClientRect().width + 24 : 320;
    };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* ---------- Hero slider ---------- */
  $$('[data-hero]').forEach(function (hero) {
    var slides = $$('[data-hero-slide]', hero);
    if (slides.length < 2) return;
    var dots = $$('[data-hero-dot]', hero);
    var idx = 0, timer;
    var dur = parseInt(hero.getAttribute('data-autoplay-speed'), 10) || 6;
    var show = function (i) {
      slides[idx].classList.remove('is-active');
      if (dots[idx]) dots[idx].removeAttribute('aria-current');
      idx = (i + slides.length) % slides.length;
      slides[idx].classList.add('is-active');
      if (dots[idx]) dots[idx].setAttribute('aria-current', 'true');
    };
    var play = function () {
      if (reduceMotion) return;
      clearInterval(timer);
      timer = setInterval(function () { show(idx + 1); }, dur * 1000);
    };
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { show(i); play(); });
    });
    var prevB = $('[data-hero-prev]', hero), nextB = $('[data-hero-next]', hero);
    if (prevB) prevB.addEventListener('click', function () { show(idx - 1); play(); });
    if (nextB) nextB.addEventListener('click', function () { show(idx + 1); play(); });
    // touch swipe
    var startX = 0;
    hero.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) { show(idx + (dx < 0 ? 1 : -1)); play(); }
    }, { passive: true });
    play();
  });

  /* ---------- Testimonials / reviews carousel ---------- */
  $$('[data-testimonials]').forEach(function (root) {
    var track = $('[data-testimonials-track]', root);
    var cards = $$('[data-testimonial-card]', root);
    if (!track || cards.length < 1) return;

    var prev = $('[data-testimonials-prev]', root.parentElement || root);
    var next = $('[data-testimonials-next]', root.parentElement || root);
    var dots = $$('[data-testimonials-dot]', root);
    var interval = parseInt(root.getAttribute('data-testimonials-interval'), 10) || 5;
    var index = 0;
    var paused = false;
    var resumeTimer = null;
    var autoTimer = null;

    var centerCard = function (i, behavior) {
      if (!cards.length) return;
      index = (i + cards.length) % cards.length;
      var card = cards[index];
      var left = card.offsetLeft - ((track.clientWidth - card.clientWidth) / 2);
      var max = Math.max(0, track.scrollWidth - track.clientWidth);
      left = Math.max(0, Math.min(left, max));
      track.scrollTo({ left: left, behavior: behavior || 'smooth' });
      cards.forEach(function (item, itemIndex) {
        item.classList.toggle('is-active', itemIndex === index);
      });
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
        dot.setAttribute('aria-selected', dotIndex === index ? 'true' : 'false');
      });
    };

    var syncActive = function () {
      var center = track.scrollLeft + (track.clientWidth / 2);
      var closest = 0;
      var closestDistance = Infinity;
      cards.forEach(function (card, cardIndex) {
        var cardCenter = card.offsetLeft + (card.clientWidth / 2);
        var distance = Math.abs(cardCenter - center);
        if (distance < closestDistance) {
          closestDistance = distance;
          closest = cardIndex;
        }
      });
      if (closest !== index) centerCard(closest, 'auto');
    };

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(syncActive);
    }, { passive: true });

    var pauseAndResume = function () {
      paused = true;
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { paused = false; }, Math.max(interval, 1800));
    };

    var startAuto = function () {
      clearInterval(autoTimer);
      if (cards.length > 1 && interval && !reduceMotion) {
        autoTimer = setInterval(function () {
          if (!paused) centerCard(index + 1);
        }, interval);
      }
    };

    track.addEventListener('pointerenter', function () { paused = true; });
    track.addEventListener('pointerleave', function () { paused = false; });
    track.addEventListener('touchstart', pauseAndResume, { passive: true });
    track.addEventListener('touchend', function () {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { paused = false; }, 1800);
    }, { passive: true });
    track.addEventListener('focusin', function () { paused = true; });
    track.addEventListener('focusout', function () { paused = false; });

    if (prev) prev.addEventListener('click', function () {
      pauseAndResume();
      centerCard(index - 1);
    });
    if (next) next.addEventListener('click', function () {
      pauseAndResume();
      centerCard(index + 1);
    });
    dots.forEach(function (dot, dotIndex) {
      dot.addEventListener('click', function () {
        pauseAndResume();
        centerCard(dotIndex);
      });
    });

    centerCard(0, 'auto');
    startAuto();
  });

  /* ---------- Count-up stats ---------- */
  (function () {
    var els = $$('[data-countup]');
    if (!els.length) return;
    var run = function (el) {
      var target = parseInt(el.getAttribute('data-countup'), 10) || 0;
      var suffix = el.getAttribute('data-countup-suffix') || '';
      if (reduceMotion) { el.textContent = target.toLocaleString('en-PK') + suffix; return; }
      var start = null;
      var step = function (ts) {
        if (!start) start = ts;
        var p = Math.min(1, (ts - start) / 1600);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased).toLocaleString('en-PK') + suffix;
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if ('IntersectionObserver' in window) {
      var io2 = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { run(en.target); io2.unobserve(en.target); }
        });
      }, { threshold: .4 });
      els.forEach(function (el) { io2.observe(el); });
    } else {
      els.forEach(run);
    }
  })();

  /* ---------- Lightbox (used by product page) ---------- */
  window.SarteCloseLightbox = closeLightbox;
  function closeLightbox() {
    var lb = $('.lightbox.is-open');
    if (!lb) return;
    lb.classList.remove('is-open');
    lockScroll(false);
  }

  /* ---------- Init ---------- */
  syncWishlistUI();
  updateCartCounts();
  renderShipProgress(0);
})();
